import ResetPwComponent from './reset-pw.vue'
export default ResetPwComponent
